import React, { Component } from 'react';
import filter from 'lodash/filter';
import head from 'lodash/head';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import Axios from 'axios';
import Spotify from 'spotify-web-api-js';
import CircularProgress from 'material-ui/CircularProgress';

import SearchResultsList from './SearchResultsList';
const SOUNDCLOUD_CLIENT_ID = '38a49a5df5b23adc363c09eab501e7c1';

class SearchResults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchResults: [],
      status: 'false',
    }
  }

  componentWillMount() {
    this.searchSwitcher(this.props.searchValue, this.props.source)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.searchValue !== nextProps.searchValue) {
      this.searchSwitcher(nextProps.searchValue, nextProps.source)
    }
  }

  searchSwitcher = (q, s) => {
    if (s === 'Spotify') this.searchWithSpotify(q)
    if (s === 'SoundCloud') this.searchWithSoundCloud(q)
  }
  
  searchWithSpotify = (q) => {
    this.setState({status: 'loading'});

    const spotifyApi = new Spotify();
    const APPS_SCRIPT_TOKEN = "https://script.google.com/macros/s/AKfycbyP2Bj6CatiqmAVm02e2iEizeLM6-hNrKv6sLeaRfvBGPFwD5Wd/exec";
    const self = this;

    Axios.get(APPS_SCRIPT_TOKEN).then((token) => {
      spotifyApi.setAccessToken(token.data.access_token);

      spotifyApi.searchTracks(q, (err, data) => {
        let searchResults;

        if (err) searchResults = ["not-found"]

        else {
          searchResults = filter(data.tracks.items, track => track.preview_url && !isEmpty(track.album.images))

          searchResults = map(searchResults, (track, i) => {
            let artists = String(map(track.artists, artist => artist.name)).replace(/,/g,", ").replace(/,(?=[^,]*$)/, " &");
            if (artists.length > 250) artists = artists.substring(0, 250) + '...'

            return {
              id: track.id,
              name: track.name,
              artists: artists,
              previewUrl: track.preview_url,
              duration: 30,
              image: head(track.album.images).url
            }
            
          })
            
          //if no results set as not found
          if (isEmpty(searchResults)) searchResults = ["not-found"];
        }

        self.setState({searchResults, status: 'hide'});
      })

    }).catch((error) => {
      self.setState({status: 'hide'})
      console.log(error)
    })
  }

  searchWithSoundCloud = (q) => {
    const self = this;

    this.setState({status: 'loading'});
    Axios.get(`https://api.soundcloud.com/tracks.json?client_id=${SOUNDCLOUD_CLIENT_ID}&q=${q}&limit=50`)
    .then(response => {
      let searchResults;

      if (isEmpty(response.data)) searchResults = ["not-found"];

      else {
        searchResults = filter(response.data, track => track.stream_url && track.artwork_url && track.streamable)

        searchResults = map(searchResults, (track, i) => ({
          id: track.id,
          name: track.title,
          artists: track.user.username,
          previewUrl: `${track.stream_url}?client_id=${SOUNDCLOUD_CLIENT_ID}`,
          duration: track.duration / 1000,
          image: track.artwork_url.replace('large', 't500x500')
        }))

        //if no results set as not found
        if (isEmpty(searchResults)) searchResults = ["not-found"];
      }

      self.setState({searchResults, status: 'hide'});
    }).catch((error) => {
      self.setState({status: 'hide'})
      console.log(error)
    })
  }

  render() {
    let resultsItem = null

    if (head(this.state.searchResults) === "not-found") {
      resultsItem =
      <div className="not-found" >
        <h2>Nothing found</h2>
        <p>Try searching for something else</p>
      </div>
    }

    else {
      resultsItem = 
      map(this.state.searchResults, track => (
        <SearchResultsList
          onPlayTrack={this.props.onPlayTrack}
          key={track.id}
          id={track.id} 
          name={track.name} 
          artists={track.artists}
          previewUrl={track.previewUrl}
          duration={track.duration}
          playing={this.props.playing}
          isPlaying={this.props.isPlaying}
          image={track.image} />
      ))
    }

    return (
      <div className="search-results" >
        <h1>
          Search results
        </h1>
        <div className="search-results--container" >
          {
            this.state.status === 'loading'
            ? <div className="refresh-indicator">
                <CircularProgress status={this.state.status} size={55} thickness={3.5} />
              </div>
            : <ul className="search-results-list" >
                {resultsItem}
              </ul>
          }
        </div>
      </div>
    );
  }
}

export default SearchResults;


// WEBPACK FOOTER //
// ./src/components/SearchResults.jsx